import { NextPage } from 'next';

import SEO from 'components/home/SEO';
import Layout from 'components/home/Layout';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { MdOutlineHealthAndSafety } from 'react-icons/md';
import { TbTestPipe2 } from 'react-icons/tb';
import CtaSection from 'components/home/CtaSection';
import FeatureRow from 'components/home/FeatureSection/FeatureRow';

const features = [
  {
    title: 'Pass/Fail Conditions',
    description:
      'Define thresholds to pass/fail your performance tests. Thresholds automatically apply to all test runs in a test scenario. Conditions can be set for response time, error counts, request counts, and more.',
    icon: <AiOutlineCheckCircle className="w-8 h-8 sm:w-14 sm:h-14" />,
  },
  {
    title: 'Automated Testing',
    description:
      'Use status checks in your test automation pipelines to determine performance health. Integrate with your CI/CD tool of choice to automatically run performance tests, report results, and pause deployments.',
    icon: <TbTestPipe2 className="w-8 h-8 sm:w-14 sm:h-14" />,
  },
  {
    title: 'Performance Benchmarks',
    description:
      'Catch performance regressions before they impact your users. Build trust and clarity in your performance monitoring as a team.',
    icon: <MdOutlineHealthAndSafety className="w-8 h-8 sm:w-14 sm:h-14" />,
    last: true,
  },
];

const ThresholdsPage: NextPage = () => {
  return (
    <>
      <SEO title="Thresholds" />
      <Layout>
        <section className="text-gray-700 body-font bg-gray-50">
          <div className="container flex flex-col items-center px-5 pt-12 pb-6 mx-auto md:flex-row">
            <div className="flex flex-col items-center text-center mb-6 md:mb-0 md:w-1/2 lg:pr-24 md:pr-16 md:items-start md:text-left">
              <h1 className="mb-4 text-3xl font-bold text-san-juan-blue-500 title-font sm:text-4xl">
                Thresholds to measure load test objectives
              </h1>
              <p className="mb-8 leading-relaxed">
                Define pass/fail conditions for your performance tests and
                monitor their health. Integrate with your CI/CD pipeline to help
                determine build status.
              </p>
              <div className="flex justify-center">
                <a
                  href="https://docs.latencylingo.com/docs/getting-started"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 shadow border border-summer-green-300 rounded focus:outline-none hover:bg-summer-green-200">
                    Learn more
                  </button>
                </a>
              </div>
            </div>
            <div className="w-5/6 mb-10 md:w-1/2 md:mb-0">
              <img
                className="object-cover object-center rounded"
                alt="hero"
                src="/img/docs/test-run-thresholds.png"
                loading="lazy"
              />
            </div>
          </div>
        </section>
        <section className="text-gray-700 pt-6 body-font">
          <div className="flex flex-wrap px-4 md:w-2/3 mx-auto">
            {features.map((feature, i) => (
              <FeatureRow key={i} title="" {...feature} />
            ))}
          </div>
        </section>
        <CtaSection learnMoreLink="https://docs.latencylingo.com/docs/getting-started" />
      </Layout>
    </>
  );
};

export default ThresholdsPage;
